import { useEffect } from "react";
import { useConsent } from "@/context/consent";

const BEACON_SRC = "https://static.cloudflareinsights.com/beacon.min.js";
const MANAGED_ATTR = "data-analytics-managed";

function getToken(): string {
	return (
		(
			window as unknown as {
				__BOOTSTRAP_DATA__?: { cfAnalyticsToken?: string };
			}
		).__BOOTSTRAP_DATA__?.cfAnalyticsToken ?? ""
	);
}

export function useCfAnalytics(): void {
	const { analytics } = useConsent();
	const token = getToken();

	useEffect(() => {
		if (analytics && token) {
			const script = document.createElement("script");
			script.defer = true;
			script.src = BEACON_SRC;
			script.setAttribute("data-cf-beacon", JSON.stringify({ token }));
			script.setAttribute(MANAGED_ATTR, "");
			document.head.appendChild(script);
		} else {
			const existing = document.querySelector(`script[${MANAGED_ATTR}]`);
			existing?.remove();
		}

		return () => {
			const managed = document.querySelector(`script[${MANAGED_ATTR}]`);
			managed?.remove();
		};
	}, [analytics, token]);
}
